import { defineMessages } from 'react-intl'

const scope = 'app.components.DashboardCharts'

export default defineMessages({
  titles: {
    businesses: {
      id: `${scope}.titles.businesses`,
      defaultMessage: 'Businesses Entities',
    },
    individuals: {
      id: `${scope}.titles.individuals`,
      defaultMessage: 'Individuals Entities',
    },
  },
})
